<template>
  <a-spin :spinning="!this.chartData">
    <h3 align="center">Exchange rate of population aging countries</h3>
    <svg align="center" id="exchange-rate-chart"></svg>
  </a-spin>
</template>

<script>
import * as d3 from "d3";
import axios from "axios";
export default {
    name: "ExchangeRateChart",
    data: function(){
        return{
            chartData: null,
        };
    },
    mounted(){
   const API = this.$store.state.API;
    if (!this.$store.state.ExRateData) {
      axios.get(`${API}affect/exchange_rate.json`).then(result => {
        this.chartData = result.data;  
        this.$store.commit('ExRateData', result.data);
        this.makeExRateChart();
        })
    } else {
      this.chartData = this.$store.state.ExRateData;
      this.makeExRateChart();
    }},
    methods:{
        makeExRateChart(){
            var data = this.chartData;
            var width = 600;
            var height = width;
            var color = d3.scaleLinear()
                .domain([0, 5])
                .range(["hsl(185, 64%, 90%)", "hsl(185, 64%, 90%)"])
                .interpolate(d3.interpolateHcl);
            var country_color = {"Japan":	"#67000d",
                        "Italy":	"#67000d",
                        "Finland":	"#67000d",
                        "France":	"#67000d",
                        "Spain":	"#67000d",
                        "United Kingdom":	"#a50f15",
                        "Canada":	"#a50f15",
                        "United States":	"#cb181d",
                        "Australia":	"#cb181d",
                        "Iceland":	"#cb181d",
                        "China":	"#fb6a4a",
                        "Chile":	"#fb6a4a",
                        "Turkey":	"#fc9272",
                        "Mexico":	"#fcbba1"}
            var pack = data => d3.pack()
                .size([width, height])
                .padding(3)(d3.hierarchy(data)
                .sum(d => +d.value)
                .sort((a, b) => +b.value - +a.value));
            var root = pack(data);
            var focus = root;
            var view;
            var svg = d3.select('#exchange-rate-chart')
                    // .attr("viewBox", [0, 0, width, height])
                    //.attr("viewBox", `-${width / 2} -${height / 2} ${width} ${height}`)
                    .attr('width', width)
                    .attr('height', height)
                    .style("display", "block")
                    .style("margin", "0 -14px")
                    .style("background", "white")
                    .style("cursor", "pointer")
                    .on("click", (event) => zoom(event, root));
            var node = svg.append("g")
                .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')
                .selectAll("circle")
                .data(root.descendants().slice(1))
                .join("circle")
                .attr("fill", d => d.children ? color(d.depth) : "white")
                .attr("pointer-events", d => !d.children ? "none" : null)
                .on("mouseover", function() { d3.select(this).attr("stroke", "#000"); })
                .on("mouseout", function() { d3.select(this).attr("stroke", null); })
                .on("click", (event, d) => focus !== d && (zoom(event, d), event.stopPropagation()));

            var label = svg.append("g")
                .attr('transform', 'translate(' + width / 2 + ',' +height / 2 + ')')
                .style("font", "10px sans-serif")
                .attr("pointer-events", "none")
                .attr("text-anchor", "middle")
                .selectAll("text")
                .data(root.descendants())
                .join("text")
                .style("fill-opacity", d => d.parent === root ? 1 : 0)
                .style("display", d => d.parent === root ? "inline" : "none")
                .text(d => !d.data.value ? d.data.name: d.data.code + '\n' + Number(d.data.value).toFixed(2))
                .style('fill', d=> country_color[d.data.name]);

            zoomTo([root.x, root.y, root.r * 2]);
            function zoomTo(v) {
                var k = width / v[2];
                view = v;
                // console.log(k)
                label.attr("transform", d => `translate(${(d.x - v[0]) * k},${(d.y - v[1]) * k})`);
                node.attr("transform", d => `translate(${(d.x - v[0]) * k},${(d.y - v[1]) * k})`);
                node.attr("r", d => !d.r < 5 ? d.r * k: d.r * k*5);
                
            }
            function zoom(event, d) {
                // var focus0 = focus;

                focus = d;

                var transition = svg.transition()
                    .duration(event.altKey ? 7500 : 750)
                    .tween("zoom", () => {
                    var i = d3.interpolateZoom(view, [focus.x, focus.y, focus.r * 2]);
                    return t => zoomTo(i(t));
                    });

                label
                .filter(function(d) { return d.parent === focus || this.style.display === "inline"; })
                .transition(transition)
                    .style("fill-opacity", d => d.parent === focus ? 1 : 0)
                    .on("start", function(d) { if (d.parent === focus) this.style.display = "inline"; })
                    .on("end", function(d) { if (d.parent !== focus) this.style.display = "none"; });
            }

        },



    }
}
</script>